import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import App from './app';
import Reset from './reset';
export default class AppShell extends React.PureComponent {
    render() {
        return (React.createElement("div", null,
            React.createElement(Switch, null,
                React.createElement(Route, { path: "/", exact: true, component: App }),
                React.createElement(Route, { path: "/reset", component: () => React.createElement(Reset, null) }),
                React.createElement(Route, { path: "/edited", component: App }),
                React.createElement(Route, { exact: true, path: "/gist/:id/:filename", component: App }),
                React.createElement(Route, { exact: true, path: "/gist/:id/:filename/view", component: App }),
                React.createElement(Route, { path: "/gist/:id/:revision/:filename", component: App }),
                React.createElement(Route, { path: "/examples/:mode/:example_name", component: App }),
                React.createElement(Route, { path: "/examples/:mode", component: () => React.createElement(App, { showExample: true }) }),
                React.createElement(Route, { path: "/examples", component: () => React.createElement(App, { showExample: true }) }),
                React.createElement(Route, { path: "/custom/:mode", component: App }),
                React.createElement(Route, { path: "/url/:mode/:compressed", component: App }))));
    }
}
